import React from "react";
import Modal from "react-modal";
import "./BookingFormData.css";

Modal.setAppElement("#root");

const StateModal = ({ isOpen, bookingId, onClose,status }) => {

  let title;
  let message;

  if (status === "success") {
    title = "Request Received";
    message = "Thank you for your request.Our travel team will review your details and contact you shortly to assist with a suitable Ranthambore tour package and safari experience.";
  } else {
    title = "Request Failed";
    message = "Something went wrong. Please try again after sometime.";
  }
  return (
    <Modal isOpen={isOpen} className="modal" overlayClassName="overlay">
      <div style={{ textAlign: "center" }}>
        
        


        {status === "success" && (
      <div style={{ fontSize: "60px", color: "green" }}>✓</div>
    )}

        <h2>{title}</h2>

        <p>{message}</p>

{/* 
{status === "success" && (
      <p>Booking ID: {bookingId}</p>
    )} */}
        

        <button onClick={onClose}>Close</button>

      </div>
    </Modal>
  );
};

export default StateModal;
